import { render, staticRenderFns } from "./ListZones.vue?vue&type=template&id=2c4fe5ce&scoped=true&"
import script from "./ListZones.vue?vue&type=script&lang=js&"
export * from "./ListZones.vue?vue&type=script&lang=js&"
import style0 from "./ListZones.vue?vue&type=style&index=0&id=2c4fe5ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4fe5ce",
  null
  
)

export default component.exports